import * as Services from "../models/swagger/generated-client-service";

export const ClientService = {
    me: Services.UsersService.me,

    myFirms: Services.FirmsService.my,

    firmAttorneys: Services.AttorneysService.firm,

    firmActiveAttorneys: Services.AttorneysService.firm1,

    getDocType: Services.RulesService.documenttype2,

    getAddresses: Services.RulesService.addresses,

    getFees: Services.RulesService.fees,

    getFirms: Services.FirmsService.firms,

    getParty: Services.RulesService.party,

    getCaseType: Services.RulesService.casetype,
    getDivision: Services.RulesService.division,
};

export const AttorneyService = {
    get: Services.AttorneysService.attorneys2,

    saveProfile: Services.AttorneysService.saveprofile,

    serviceContacts: Services.ServiceContactService.attorney,

    addServiceContacts: Services.ServiceContactService.serviceContact1,

    updateServiceContacts: Services.ServiceContactService.serviceContact3,

    deleteServiceContacts: Services.ServiceContactService.serviceContact4,

    getFTPInfo: Services.FtpInfoService.attorney,

    saveAutomation: Services.AttorneysService.saveautomation,

    savePendingQueue: Services.AttorneysService.savependingqueue,

    saveService: Services.AttorneysService.saveservice,

    caseNumberRegex: Services.CaseNumberRegexService.attorney,
    addCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex1,
    updateCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex3,
    deleteCaseNumberRegex: Services.CaseNumberRegexService.caseNumberRegex4,

    correctionQueue: Services.AttorneysService.correctionqueue,

    updateByDirectory: Services.AttorneysService.update,

    getBlackListEmail: Services.AttorneysService.getblacklist,
    addBlackListEmail: Services.AttorneysService.addblacklist,
    updateBlackListEmail: Services.AttorneysService.updateblacklist,
    deleteBlackListEmail: Services.AttorneysService.deleteblacklist,

    //getPortalConfigurations: Services.AttorneysService.portalConfiguration,
};

export const PortalConfigurationService = {
    getList: Services.PortalConfigurationService.getlist,

    add: Services.PortalConfigurationService.add,

    update: Services.PortalConfigurationService.update,

    getCredentials: Services.PortalConfigurationService.getCredentials,

    delete: Services.PortalConfigurationService.portalConfiguration4,
};

export const OrganizationService = {
    getList: Services.OrganizationsService.organizations,

    get: Services.OrganizationsService.organizations3,

    add: Services.OrganizationsService.organizations2,

    update: Services.OrganizationsService.organizations1,

    delete: Services.OrganizationsService.organizations4,

    users: Services.OrganizationsService.users,

    registerUser: Services.OrganizationsService.registerUser,

    firms: Services.OrganizationsService.firms,
    getFirmsFromOrg: Services.OrganizationsService.getFirms,
    isFileDrop: Services.OrganizationsService.fileDrop,
};

export const UserService = {
    register: Services.UsersService.register,

    verify: Services.UsersService.verify,

    getList: Services.UsersService.users1,

    add: Services.UsersService.users,

    update: Services.UsersService.users2,

    delete: Services.UsersService.users4,

    roles: Services.RolesService.roles,

    me: Services.UsersService.me,

    forgotPassword: Services.UsersService.forgotPassword,

    resetPassword: Services.UsersService.resetPassword,

    sendEmail: Services.UsersService.sendRegistration,

    getAttorneys: Services.UsersService.getUserAttorneys,
    getAllAttorneys: Services.UsersService.getAllUserAttorneys,
    getUserAttorneysByFirm: Services.UsersService.getUserAttorneysByFirm,
    linkUserAttorneys: Services.UsersService.attorneys,

    resendConfirmationEmail: Services.UsersService.resendConfirmationCode,
};

export const DocumentRulesService = {
    getRule: Services.DocumentTypeRulesService.rule,

    getList: Services.DocumentTypeRulesService.attorney,

    update: Services.DocumentTypeRulesService.documentTypeRules3,

    add: Services.DocumentTypeRulesService.documentTypeRules1,

    delete: Services.DocumentTypeRulesService.documentTypeRules4,
};

export const CaseTypeRulesService = {
    getRule: Services.CaseTypeRulesService.rule,

    getList: Services.CaseTypeRulesService.attorney,

    update: Services.CaseTypeRulesService.caseTypeRules3,

    add: Services.CaseTypeRulesService.caseTypeRules1,

    delete: Services.CaseTypeRulesService.caseTypeRules4,
};

export const DivisionRulesService = {
    getRule: Services.DivisionRulesService.rule,

    getList: Services.DivisionRulesService.attorney,

    update: Services.DivisionRulesService.divisionRules3,

    add: Services.DivisionRulesService.divisionRules1,

    delete: Services.DivisionRulesService.divisionRules4,
};

export const MessageRulesService = {
    getRule: Services.MessageRulesService.rule,

    rule: Services.RulesService.messages,

    getList: Services.MessageRulesService.attorney,

    update: Services.MessageRulesService.messageRules3,

    add: Services.MessageRulesService.messageRules1,

    delete: Services.MessageRulesService.messageRules4,
};

export const FeeRuleService = {
    getRule: Services.FeeRuleService.rule,

    getList: Services.FeeRuleService.attorney,

    get: Services.FeeRuleService.feeRule,

    update: Services.FeeRuleService.feeRule3,

    add: Services.FeeRuleService.feeRule1,

    delete: Services.FeeRuleService.feeRule4,
};

export const TylerAdminService = {
    login: Services.AdminService.login,
    getUsers: Services.AdminService.users,
    addUser: Services.AdminService.users1,
    putUser: Services.AdminService.users2,
    getUser: Services.AdminService.users3,
    deleteUser: Services.AdminService.users4,
    getServiceContacts: Services.AdminService.serviceContacts,
    addServiceContact: Services.AdminService.serviceContacts1,
    updateServiceContact: Services.AdminService.serviceContacts2,
    deleteServiceContact: Services.AdminService.serviceContacts3,
    getAttorneys: Services.AdminService.attorneys,
    addAttorney: Services.AdminService.attorneys1,
    updateAttorney: Services.AdminService.attorneys2,
    getAttorney: Services.AdminService.attorneys3,
    deleteAttorney: Services.AdminService.attorneys4,
    getMyFirm: Services.AdminService.firm,
};

export const TylerPaymentService = {
    getAll: Services.TylerPaymentService.tylerPayment,
    get: Services.TylerPaymentService.tylerPayment3,
    add: Services.TylerPaymentService.tylerPayment1,
    link: Services.TylerPaymentService.link,
    update: Services.TylerPaymentService.tylerPayment2,
    delete: Services.TylerPaymentService.tylerPayment4,
};

export const MatterService = {
    getAll: Services.MatterManagmentService.org,
    get: Services.MatterManagmentService.populated,
    add: Services.MatterManagmentService.org1,
    nextMatter: Services.MatterManagmentService.next,
    merge: Services.MatterManagmentService.merge,
};
